import {
  IconBag,
  IconCar,
  IconCoat,
  IconKey,
  IconTransfer,
  IconUmbrella,
  IconWineGlass,
} from '@tock/icons';
import { SvgIconProps } from '@material-ui/core';
import IconTagBag from 'components/icons/svgr/tag-icons/IconTagBag';
import IconTagCar from 'components/icons/svgr/tag-icons/IconTagCar';
import IconTagCoat from 'components/icons/svgr/tag-icons/IconTagCoat';
import IconTagKey from 'components/icons/svgr/tag-icons/IconTagKey';
import IconTagTransfer from 'components/icons/svgr/tag-icons/IconTagTransfer';
import IconTagUmbrella from 'components/icons/svgr/tag-icons/IconTagUmbrella';
import IconWineDirect from 'components/icons/svgr/IconWineDirect';

const PartyNeedsName = {
  bag: 'Bags',
  coat: 'Coats',
  taxi: 'Taxi',
  transfer: 'Transfer',
  umbrella: 'Umbrellas',
  valet: 'Valet',
  wine: 'Wine',
};

export { PartyNeedsName };

interface NeedsIconSet {
  [iconName: string]: {
    legacyIcon: React.FunctionComponent<React.PropsWithChildren<React.SVGProps<SVGSVGElement>>>;
    newIcon: React.FunctionComponent<React.PropsWithChildren<SvgIconProps>>;
  };
}

const NeedsNameMapping: NeedsIconSet = {
  [PartyNeedsName.bag]: { legacyIcon: IconTagBag, newIcon: IconBag },
  [PartyNeedsName.coat]: { legacyIcon: IconTagCoat, newIcon: IconCoat },
  [PartyNeedsName.wine]: { legacyIcon: IconWineDirect, newIcon: IconWineGlass },
  [PartyNeedsName.taxi]: { legacyIcon: IconTagCar, newIcon: IconCar },
  [PartyNeedsName.umbrella]: { legacyIcon: IconTagUmbrella, newIcon: IconUmbrella },
  [PartyNeedsName.valet]: { legacyIcon: IconTagKey, newIcon: IconKey },
  [PartyNeedsName.transfer]: { legacyIcon: IconTagTransfer, newIcon: IconTransfer },
};

export default NeedsNameMapping;
